import styled from 'styled-components';

const Container = styled.div`
  background-color: #fff;
  padding: 25px;
  box-shadow: 0 0 1px #eaeaea inset;
  max-width: 376px;
  max-height: 116px;

  p {
    font-size: 16px;
    color: #2c2c2c;
    font-weight: bold;
    margin-top: 0;
  }

  .button-stretch {
    width: 100%;
    margin: 0;
    font-size: 12px;
  }

  .button-stretch:last-child {
    margin-left: 10px;
  }
`;

export default Container;
